module.exports = __webpack_public_path__ + "img/vacature-verzonden.cab7c00.gif";